export const WEB_TO_EXT_PROXY_MESSAGE_TYPE = 'HEY_EXTENSION_PLS_FORWARD_TO_BG_KTHNX'

export const EXT_TO_WEB_TYPE = 'YO_SITE_HEAR_THESE_EXTENSION_WORDS'
